// extracted by mini-css-extract-plugin
export default {"BillMainBox":"Budget_BillMainBox__ysY36","BillNotCheck":"Budget_BillNotCheck__Dvecx"};